export enum ReminderType {
    Reminder1,
    Reminder2,
    Reminder3
}